/*========CHANGE PASSWORD========= */
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL    = 'CHANGE_PASSWORD_FAIL';

/*========CHANGE PASSWORD 2========= */
export const CHANGE_PASSWORD2_SUCCESS = 'CHANGE_PASSWORD2_SUCCESS';
export const CHANGE_PASSWORD2_FAIL    = 'CHANGE_PASSWORD2_FAIL';

export const CHANGE_PASSWORD_TOGGLE_NOTIFY    = 'CHANGE_PASSWORD_TOGGLE_NOTIFY';
